export const germanTranslations = {
  // Meta & General
  pageTitle: "AI-Marketingvideos für Unternehmen | Future Level Schweiz",
  pageDescription: "Professionelle Marketingvideos mit KI – Future Level spart Zeit und Kosten durch automatisierte Videoproduktion für Unternehmen in der Schweiz.",
  
  // Navigation
  home: "Startseite",
  services: "Leistungen",
  whyFutureLevel: "Warum Future Level?",
  blog: "Blog",
  contact: "Kontakt",
  breadcrumbNavigation: "Brotkrümelnavigation",
  
  // Pricing Page
  pricing: "Preise",
  pricingSubtitle: "Transparente Preise für KI-Videoproduktion mit bestem Preis-Leistungs-Verhältnis",
  pricingDescription: "Entdecken Sie unsere transparenten Preismodelle für KI-basierte Videoproduktion: Von Einzelvideos bis zu monatlichen Abos.",
  
  // Service Names
  productVideos: "Produktvideos",
  kiVideoProductShowcase: "KI-Produktvideos",
  explainerVideos: "Erklärvideos",
  socialMediaAds: "Social Media Ads",
  reels: "Reels",
  
  // Service Descriptions
  productVideosDesc: "Zeigen Sie Ihre Produkte im besten Licht – automatisch, schnell, überzeugend.",
  explainerVideosDesc: "Komplexe Inhalte einfach und verständlich per KI erklärt.",
  socialMediaAdsDesc: "Hochperformante Kurzvideos für Ihre Kampagnen auf Instagram, Facebook, TikTok & Co.",
  reelsDesc: "Maximale Reichweite dank trendiger KI-Reels in Ihrem Branding.",
  
  // Hero Section
  heroTitle: "KI-basierte Videomarketing Lösungen für Ihr Business",
  heroSubtitle: "Zeit & Kosten sparen, ROI maximieren",
  contactUs: "Kontaktieren Sie uns",
  learnMore: "Mehr erfahren",
  
  // Why Future Level
  whyFutureLevelSubtitle: "Unsere AI-Technologie erstellt Videos schneller als jede Agentur – ohne Schauspieler, Kamera oder Studio.",
  costSaving: "Kosten sparen",
  timeSaving: "Zeit sparen",
  increaseSales: "Verkaufszahlen steigern",
  targetAudience: "Massgeschneidert für Ihre Zielgruppe",
  costSavingDesc: "Reduzieren Sie Ihre Produktionskosten um bis zu 70% im Vergleich zu herkömmlichen Videoproduktionen.",
  timeSavingDesc: "Erhalten Sie Ihre fertigen Videos innerhalb weniger Tage statt Wochen oder Monaten.",
  increaseSalesDesc: "Steigern Sie Ihre Conversion-Rate und Umsätze durch überzeugende visuelle Inhalte.",
  targetAudienceDesc: "Jedes Video wird genau auf Ihre Zielgruppe und Branche abgestimmt.",
  
  // Why KI Videos Section
  whyKIVideosTitle: "KI Social Media Videos: 300% mehr Engagement & 70% Kostenersparnis",
  whyKIVideosPoint1: "Expertenteam mit fortschrittlichen KI-Tools für Instagram, TikTok & Facebook Videos - stets auf dem neuesten Stand der Technologie",
  whyKIVideosPoint2: "Team aus ausschließlich professionellen Video-Editoren mit langjähriger Erfahrung in digitaler Videoproduktion",
  whyKIVideosPoint3: "Vollständige Fokussierung auf Ihren Erfolg durch maßgeschneiderte KI-gestützte Videostrategien",
  whyKIVideosPoint4: "Professionelles Team mit Expertise in allen Social Media Formaten (Instagram Reels, Facebook Ads, TikTok)",
  
  // Services Section
  ourServices: "Unsere Leistungen",
  servicesSubtitle: "Professionelle KI-basierte Marketingvideos, die Ihre Botschaft wirkungsvoll vermitteln.",
  
  // Testimonials
  clientTestimonials: "Kundenstimmen",
  testimonialsSubtitle: "Was unsere Kunden über uns sagen",
  testimonial1: "Die KI-Videos von Future Level haben die Conversion-Rate in unserem Online-Shop um 35% gesteigert. Unglaubliches Preis-Leistungs-Verhältnis!",
  testimonial2: "Wir nutzen die Erklärvideos für komplexe Beratungsthemen. Unsere Kunden sind begeistert, wie verständlich die Inhalte aufbereitet sind.",
  testimonial3: "Die Social Media Ads haben unserer Klinik zu einer deutlich höheren lokalen Bekanntheit verholfen. Der ROI ist beeindruckend.",
  
  // Blog Section
  latestBlogPosts: "Aktuelle Blog-Beiträge",
  blogSubtitle: "Trends und Tipps rund um Videomarketing und KI im Marketing",
  blogTitle1: "Video-Marketing Trends 2025",
  blogExcerpt1: "Welche Video-Formate und Technologien dominieren das Marketing in diesem Jahr? Einblicke und Prognosen.",
  blogTitle2: "KI im Marketing - Revolution oder Hype?",
  blogExcerpt2: "Wie Künstliche Intelligenz das Marketing nachhaltig verändert und welche Chancen sich für Unternehmen ergeben.",
  blogTitle3: "Case Study: Erfolgreiche Video-Kampagnen",
  blogExcerpt3: "Analyse von drei besonders erfolgreichen Video-Kampagnen und was Sie daraus lernen können.",
  readMore: "Weiterlesen",
  viewAllPosts: "Alle Beiträge anzeigen",
  
  // Blog Page
  blogPageTitle: "Expertenwissen: Videomarketing & KI",
  blogPageSubtitle: "Aktuelle Trends, praktische Tipps und Erfolgsgeschichten aus der Welt des KI-basierten Videomarketings",
  blogMetaDescription: "Der Future Level Blog bietet Expertenwissen zu KI-Videomarketing, Trends und Best Practices für Unternehmen in der Schweiz.",
  backToBlog: "Zurück zum Blog",
  blogContentPlaceholder: "Dieser Abschnitt enthält detaillierte Informationen zum Thema. In einer Live-Website würde hier der vollständige Artikel-Inhalt stehen.",
  blogSubheading1: "Die wichtigsten Erkenntnisse",
  blogSubheading2: "Praktische Anwendungen",
  blogSubheading3: "Fazit und Ausblick",
  blogCTA: "Möchten Sie mehr über unsere KI-Videolösungen erfahren?",
  
  // Contact Form
  contactSubtitle: "Bereit, Ihre Video-Marketingstrategie mit KI zu revolutionieren? Füllen Sie unser Kontaktformular aus – wir melden uns innerhalb von 24 Stunden.",
  fullName: "Vollständiger Name",
  email: "E-Mail",
  company: "Unternehmen",
  phone: "Telefonnummer",
  projectDescription: "Projektbeschreibung",
  send: "Absenden",
  formSubmitSuccess: "Nachricht gesendet!",
  formSubmitMessage: "Vielen Dank für Ihre Anfrage. Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.",
  
  // Clients Section
  trustedBy: "Diesen Unternehmen vertrauen uns",
  
  // Legal Page
  tableOfContents: "Inhaltsverzeichnis",
  legalTitle: "Impressum",
  legalDescription: "Unternehmensdetails und rechtliche Informationen zur KI-Videomarketing Agentur in Kriens, Schweiz",
  contactInfo: "Kontakt",
  companyDetails: "Handelsregistereintrag",
  vatInfo: "Mehrwertsteuer",
  authorizedRepresentative: "Vertretungsberechtigte Person",
  legalNotices: "Rechtliche Hinweise",
  disclaimer: "Haftungsausschluss",
  copyright: "Urheberrecht",
  lastUpdated: "Stand: Mai 2025",
  backToTop: "Zurück zum Anfang",
  collapseTOC: "Inhaltsverzeichnis einklappen",
  expandTOC: "Inhaltsverzeichnis ausklappen",
  navigateToSection: "Navigiere zum Abschnitt",
  
  // New SEO-focused keywords based on research
  kiVideo: "KI-Video",
  videoMarketing: "Videomarketing",
  socialMediaMarketing: "Social Media Marketing",
  digitalMarketing: "Digitales Marketing",
  aiContentCreation: "KI-Inhaltserstellung",
  
  // Industry-specific terms
  financeSector: "Finanzsektor",
  luxuryBrands: "Luxusmarken",
  tourism: "Tourismusbranche",
  healthcare: "Gesundheitswesen",
  startups: "Startups und Technologieunternehmen",
  
  // Location specific
  zurich: "Zürich",
  geneva: "Genf",
  basel: "Basel",
  bern: "Bern",
  lausanne: "Lausanne",
  
  // Accessibility enhanced translations
  skipToContent: "Zum Hauptinhalt springen",
  mainContent: "Hauptinhalt",
  mainNavigation: "Hauptnavigation",
  closeMenu: "Menü schliessen",
  openMenu: "Menü öffnen",
  
  // Footer
  footerDescription: "Future Level - Ihr Partner für KI-basierte Marketingvideos in der Schweiz. Steigern Sie Ihren Erfolg mit innovativen Videolösungen.",
  quickLinks: "Schnellzugriff",
  allRightsReserved: "Alle Rechte vorbehalten.",
  impressum: "Impressum",
  privacy: "Datenschutz",
  terms: "AGB"
};
